import React, { useState } from "react";
import CartModal from "./cart/cart-modal";
import ProductDetails from "./product/product-details";
import Progress from "./cart/progress";
import { useAppSelector } from "../../../slice/hooks";
import { getActiveCart } from "../../../slice/cart-slice";
import styles from "./index.module.scss";

const StoreModal = ({
  showCart,
  showProduct,
  closeModal,
  modalState,
  modalData,
  accessPoint,
  activateBackButton,
  showProgress,
  setShowProgress,
  checkoutState,
  setCheckoutState,
  organisation,
}) => {
  const [publicUser, setPublicUser] = useState(null);

  const handleActivateBackButton = (show, onClickBackButton = null) => {
    activateBackButton?.(show, onClickBackButton);
    setShowProgress(show);
  };

  const cart = useAppSelector(getActiveCart);

  return (
    <div>
      {showProgress && modalState !== "product" && (
        <div className={styles.progressbox}>
          <Progress
            checkoutState={checkoutState}
            setCheckoutState={setCheckoutState}
            accessPoint={accessPoint}
            publicUser={publicUser}
          />
        </div>
      )}

      <section>
        {!cart && modalState === "checkout" ? (
          <div className={styles.cart}>
            <h1>Shopping cart is unavailable </h1>
            <p>
              Shopping cart services are currently down, please refresh the page
              or try again later, Thank you.
            </p>
          </div>
        ) : (
          <div className={styles.cart}>
            {modalState === "checkout" && (
              <CartModal
                closeModal={closeModal}
                showProduct={showProduct}
                activateBackButton={handleActivateBackButton}
                setCheckoutState={setCheckoutState}
                setPublicUser={setPublicUser}
                cart={cart}
                accessPoint={accessPoint}
                checkoutState={checkoutState}
                publicUser={publicUser}
                organisation={organisation}
                setShowProgress={setShowProgress}
              />
            )}

            {modalState == "product" && (
              <ProductDetails
                cart={cart}
                closeModal={closeModal}
                product={modalData}
                showCart={showCart}
                accessPoint={accessPoint}
                enablePreview={false}
                organisation={organisation}
              />
            )}
          </div>
        )}
      </section>
    </div>
  );
};

export default StoreModal;
